import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CorrespondenceActionPartyStoreActions,
  CorrespondenceActionPartyStoreSelectors,
  CorrespondenceActionPartyStoreReducer,
} from './index';
import { CorrespondenceActionPartyDto } from '@cradua/data';

@Injectable()
export class CorrespondenceActionPartyFacade {
  constructor(
    private store: Store<
      CorrespondenceActionPartyStoreReducer.CorrespondenceActionPartyPartialState
    >
  ) {}

  correspondenceActionParty$ = this.store.select(
    CorrespondenceActionPartyStoreSelectors.getSelected
  );
  correspondenceActionPartyError$ = this.store.select(
    CorrespondenceActionPartyStoreSelectors.getCorrespondenceActionPartyError
  );

  getselected() {
    return this.store.select(
      CorrespondenceActionPartyStoreSelectors.getSelected
    );
  }

  get isLoadingCorrespondenceActionParty() {
    this.store.dispatch(
      CorrespondenceActionPartyStoreActions.loadCorrespondenceActionParty()
    );
    return this.store.select(
      CorrespondenceActionPartyStoreSelectors.loadingCorrespondenceActionParty
    );
  }

  get loadCorrespondenceActionParty() {
    this.store.dispatch(
      CorrespondenceActionPartyStoreActions.loadCorrespondenceActionParty()
    );
    return this.store.select(
      CorrespondenceActionPartyStoreSelectors.getAllCorrespondenceActionParty
    );
  }

  addCorrespondenceActionParty(
    newCorrespondenceActionParty: CorrespondenceActionPartyDto[]
  ) {
    this.store.dispatch(
      CorrespondenceActionPartyStoreActions.addCorrespondenceActionParty({
        newCorrespondenceActionParty,
      })
    );
  }

  updateCorrespondenceActionParty(
    updateCorrespondenceActionParty: CorrespondenceActionPartyDto[]
  ) {
    this.store.dispatch(
      CorrespondenceActionPartyStoreActions.updateCorrespondenceActionParty({
        updateCorrespondenceActionParty,
      })
    );
  }

  removeCorrespondenceActionParty(ids: string[]) {
    this.store.dispatch(
      CorrespondenceActionPartyStoreActions.removeCorrespondenceActionParty({
        ids,
      })
    );
  }
}
